/* eslint-disable import/prefer-default-export */
import { watch, onMounted } from 'vue';
import { useBag, useBagContext } from '@modules/add-to-bag';

/**
 * @param {Partial<Record<import('../../types').GIFT_CARD_FIELDS, string>>} values
 */
export const useGiftBasicPreselect = (values) => {
  const bag = useBag();
  const { sequenceNumber, isUpdateBagEnabled } = useBagContext();
  watch(bag.result, (newBag) => {
    const targetItem = newBag
      .sections
      .bagItems
      .items
      .find((item) => item.sequenceNumber === sequenceNumber);

    if (!targetItem) {
      return;
    }

    const giftCardAmount = targetItem.itemTotalBeforeDiscount.toString();
    values.giftCardAmount = giftCardAmount;

    if (targetItem.giftCard) {
      values.giftCardMessage = targetItem.giftCard.message || '';
      values.giftCardFromName = targetItem.giftCard.fromMessage || '';
      values.giftCardToName = targetItem.giftCard.toMessage || '';
      values.giftCardEmailId = targetItem.giftCard.giftCardEmailId || '';
    }
  });

  onMounted(() => {
    if (!isUpdateBagEnabled) {
      return;
    }
    bag.fetch();
  });
};
